module.exports = __webpack_public_path__ + "static/img/partner-rayson.6c2a826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-rayson.png
// module id = HV41
// module chunks = 34